import { createSlice } from "redux-starter-kit";

/**
 * Interface that defines the redux state for metrics.
 *
 * @export
 * @interface MetricsState
 */
export interface MetricsState {
  config: {
    siteName: string;
    serviceName: string;
    isProduction: boolean;
    sessionId: string;
  };
}

const initialState: MetricsState = {
  config: {
    siteName: "",
    serviceName: "",
    isProduction: false,
    sessionId: "",
  },
};

export const EMPTY_METRICS_STATE = initialState;

/**
 * Creates and exports slice that defines metrics redux state, actions and reducers.
 *
 * @export
 * @constant metrics
 */
export default createSlice({
  initialState,
  slice: "metrics",
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
    },
  },
});
